/* eslint-disable camelcase */
export enum BiddingTypes {
  GET_BIDDINGS_REQUEST = '@onlineSearch/GET_BIDDINGS_REQUEST',
  GET_BIDDINGS_SUCCESS = '@onlineSearch/GET_BIDDINGS_SUCCESS',
  GET_BIDDINGS_FAILURE = '@onlineSearch/GET_BIDDINGS_FAILURE',
  GET_BIDDING_REQUEST = '@onlineSearch/GET_BIDDING_REQUEST',
  GET_BIDDING_SUCCESS = '@onlineSearch/GET_BIDDING_SUCCESS',
  GET_BIDDING_FAILURE = '@onlineSearch/GET_BIDDING_FAILURE',
  GET_BIDDING_PR_BW_REQUEST = '@onlineSearch/GET_BIDDING_PR_BW_REQUEST',
  GET_BIDDING_PR_BW_SUCCESS = '@onlineSearch/GET_BIDDING_PR_BW_SUCCESS',
  GET_BIDDING_PR_BW_FAILURE = '@onlineSearch/GET_BIDDING_PR_BW_FAILURE',
  UPDATE_STORE_FIELDS = '@onlineSearch/UPDATE_STORE_FIELDS',
  CREATE_BIDDING_FAVORITE_REQUEST = '@onlineSearch/CREATE_BIDDING_FAVORITE_REQUEST',
  CREATE_BIDDING_FAVORITE_SUCCESS = '@onlineSearch/CREATE_BIDDING_FAVORITE_SUCCESS',
  CREATE_BIDDING_FAVORITE_FAILURE = '@onlineSearch/CREATE_BIDDING_FAVORITE_FAILURE',
  DESTROY_BIDDING_FAVORITE_REQUEST = '@onlineSearch/DESTROY_BIDDING_FAVORITE_REQUEST',
  DESTROY_BIDDING_FAVORITE_SUCCESS = '@onlineSearch/DESTROY_BIDDING_FAVORITE_SUCCESS',
  DESTROY_BIDDING_FAVORITE_FAILURE = '@onlineSearch/DESTROY_BIDDING_FAVORITE_FAILURE',
  DESTROY_BIDDING_FAVORITE_ALL_REQUEST = '@onlineSearch/DESTROY_BIDDING_FAVORITE_ALL_REQUEST',
  DESTROY_BIDDING_FAVORITE_ALL_SUCCESS = '@onlineSearch/DESTROY_BIDDING_FAVORITE_ALL_SUCCESS',
  DESTROY_BIDDING_FAVORITE_ALL_FAILURE = '@onlineSearch/DESTROY_BIDDING_FAVORITE_ALL_FAILURE',
  CREATE_BIDDING_MANAGED_REQUEST = '@onlineSearch/CREATE_BIDDING_MANAGED_REQUEST',
  CREATE_BIDDING_MANAGED_SUCCESS = '@onlineSearch/CREATE_BIDDING_MANAGED_SUCCESS',
  CREATE_BIDDING_MANAGED_FAILURE = '@onlineSearch/CREATE_BIDDING_MANAGED_FAILURE',
  DESTROY_BIDDING_MANAGED_REQUEST = '@onlineSearch/DESTROY_BIDDING_MANAGED_REQUEST',
  DESTROY_BIDDING_MANAGED_SUCCESS = '@onlineSearch/DESTROY_BIDDING_MANAGED_SUCCESS',
  DESTROY_BIDDING_MANAGED_FAILURE = '@onlineSearch/DESTROY_BIDDING_MANAGED_FAILURE',
  GET_COMMENTS_REQUEST = '@onlineSearch/GET_COMMENTS_REQUEST',
  GET_COMMENTS_SUCCESS = '@onlineSearch/GET_COMMENTS_SUCCESS',
  GET_COMMENTS_FAILURE = '@onlineSearch/GET_COMMENTS_FAILURE',
  CREATE_COMMENT_REQUEST = '@onlineSearch/CREATE_COMMENT_REQUEST',
  CREATE_COMMENT_SUCCESS = '@onlineSearch/CREATE_COMMENT_SUCCESS',
  CREATE_COMMENT_FAILURE = '@onlineSearch/CREATE_COMMENT_FAILURE',
  DESTROY_COMMENT_REQUEST = '@onlineSearch/DESTROY_COMMENT_REQUEST',
  DESTROY_COMMENT_SUCCESS = '@onlineSearch/DESTROY_COMMENT_SUCCESS',
  DESTROY_COMMENT_FAILURE = '@onlineSearch/DESTROY_COMMENT_FAILURE',
  SOLICITAR_EDITAL_REQUEST = '@onlineSearch/SOLICITAR_EDITAL_REQUEST',
  SOLICITAR_EDITAL_SUCCESS = '@onlineSearch/SOLICITAR_EDITAL_SUCCESS',
  SOLICITAR_EDITAL_FAILURE = '@onlineSearch/SOLICITAR_EDITAL_FAILURE',
  GET_BIDDING_EXPIRED_REQUEST = '@onlineSearch/GET_BIDDING_EXPIRED_REQUEST',
  GET_BIDDING_EXPIRED_SUCCESS = '@onlineSearch/GGET_BIDDING_EXPIRED_SUCCESS',
  GET_BIDDING_EXPIRED_FAILURE = '@onlineSearch/GET_BIDDING_EXPIRED_FAILURE',
  BIDDINGS_OVERVIEW_REQUEST = '@onlineSearch/BIDDINGS_OVERVIEW_REQUEST',
  BIDDINGS_OVERVIEW_SUCCESS = '@onlineSearch/BIDDINGS_OVERVIEW_SUCCESS',
  BIDDINGS_OVERVIEW_FAILURE = '@onlineSearch/BIDDINGS_OVERVIEW_FAILURE',
}

export interface BiddingContractFile {
  id: number;
  url: string;
  document_type_name: string;
  document_title: string;
  publication_date_pncp: string;
}

export interface BiddingContract {
  id: number;
  nome_fornecedor: string;
  valor_contratado: number;
  data_assinatura: string;
  vigencia_inicio: string;
  vigencia_fim: string;
  files: BiddingContractFile[];
}

export interface BiddingInfoType {
  id: number;
  type_name: string;
}

export interface BiddingInfoSubtype {
  id: number;
  subtype_name: string;
}

export interface BiddingInfoTotal {
  clarification: number;
  impugnation: number;
  warning: number;
  recourse: number;
  diligence: number;
}

export interface BiddingInfoUrls {
  id: number;
  url: string;
  filename: string;
  detail_type_subtype_id: number;
}

export interface BiddingInfoDetailTypeSubtype {
  id: number;
  reference: string;
  description: string;
  source_id: number;
  message_date: string;
  bidding_id: number;
  detail_id: number;
  type_id: number;
  subtype_id: number;
  detail: number;
  type: BiddingInfoType;
  subtype: BiddingInfoSubtype;
  urls: Array<BiddingInfoUrls>;
}

export interface BiddingInfoTypes {
  id: number;
  title: string;
  reference: string;
  situation: string;
  message_date: string;
  source_id: number;
  bidding_id: number;
  type_id: number;
  detail_type_subtypes: Array<BiddingInfoDetailTypeSubtype>;
  total: BiddingInfoTotal;
}

export interface StatusBiddingInfoTypes {
  id: number;
  status_name: string;
  bidding_id: number;
  url_portal: string;
}

export interface StateBiddingsFutureTypes {
  total: number;
  estado_name: string;
}
export interface CapagTypes {
  id: number;
  capag: string;
  city_id: number;
  state_id: number;
  debt_rating: string;
  debt_ratio: string;
  current_savings_rating: string;
  current_savings_ratio: string;
  relative_liquidity_rating: string;
  relative_liquidity_ratio: string;
}
export interface PublicBodyTypes {
  id: number;
  nome: string;
  tipo_orgao_id?: number;
  tem_capag?: boolean;
  capag?: CapagTypes;
}
export interface BiddingGroupingTypes {
  descricao: string;
  resumo?: string;
  id?: number;
}
export interface ModalityTypes {
  nome: string;
}
export interface EdictsTypes {
  filename: string;
  url: string;
}
export interface ElectronicTradingTypes {
  id: number;
  edital: string;
  promoter: string;
  source_id: number;
  trading_id: string;
  trading_situation: string;
  uasg: string;
  trading_extract_url?: string;
}
export interface PhoneTypes {
  ddd: string;
  telefone: string;
  ramal: string;
}

export interface GestaoTypes {
  managing: boolean;
  members: Array<string>;
}

export interface FollowupTypes {
  data_fonte: string;
  edital: string;
  id: number;
  objeto: string;
  orgao_cidade: string;
  orgao_estado: string;
  processo: string;
  sintese: string;
  licitacao_fonte_id: number;
}

export interface CommentDataTypes {
  contact_client: {
    id: number;
    nome: string;
  };
  created_at: string;
  id: number;
  message: string;
}

export interface BiddingTaskChecklistItem {
  id: number;
  content: string;
  done: boolean;
  position: number;
}

export interface BiddingTaskAttachment {
  id: number;
  filename: string;
  url: string;
  created_at: string;
}

export interface BiddingTaskComment {
  id: number;
  text: string;
  created_at: string;
  author: { id: number; name: string } | null;
}

export interface BiddingTaskTypes {
  id: number;
  title: string;
  description: string | null;
  deadline: string | null;
  status: string;
  state: string;
  task_column_id: number;
  finished_at: string | null;
  position: number;
  responsible: { id: number; name: string } | null;
  counts: { attachments: number; comments: number };
  checklist: { total: number; done: number };
  checklist_items?: Array<BiddingTaskChecklistItem>;
  attachments?: Array<BiddingTaskAttachment>;
  comments?: Array<BiddingTaskComment>;
}

export interface ManagedBy {
  user_id: number;
  name: string;
}
export interface MonitoredBy {
  user_id: number;
  name: string;
}

export interface BiddingItemJson {
  numero_item: number;
  numero_lote: number | null;
  descricao: string;
  unidade: string | null;
  quantidade: number;
  valor_unitario: number;
  valor_total: number;
  valor_estimado: number;
  exclusividade: string | null;
}

export interface BiddingData {
  id: number;
  bidding_grouping: BiddingGroupingTypes;
  bidding_id: string;
  total_managed_opened_tasks?: number;
  created: string;
  datahora_validade: string;
  datahora_abertura: string | null;
  datahora_prazo: string | null;
  datahora_documento: string | null;
  datahora_retirada: string | null;
  datahora_visita: string | null;
  data_validade: string | null;
  edicts: Array<EdictsTypes>;
  edital: string;
  edital_homepage1: string;
  edital_homepage2: string;
  edital_preco: number;
  edital_site: string;
  edital_status_id: number;
  edital_tem: boolean;
  electronic_trading: ElectronicTradingTypes;
  email: string;
  favorited: boolean;
  favorited_by: Array<string>;
  viewed_by_user: boolean;
  viewed_by: Array<string>;
  faxes: Array<PhoneTypes>;
  followups: Array<FollowupTypes>;
  fonte_id: number;
  gestao?: GestaoTypes;
  has_electronic_trading: boolean;
  itens: string;
  itens_json?: BiddingItemJson[];
  managed: boolean;
  modality: ModalityTypes;
  modified: string;
  monitored_by_user: boolean;
  objeto: string;
  observacao: string;
  orgao_cep: string;
  orgao_cidade: string;
  orgao_endereco: string;
  orgao_estado: string;
  orgao_nome: string;
  orgao_uasg: string;
  phones: Array<PhoneTypes>;
  processo: string;
  public_body: PublicBodyTypes;
  valor_estimado: number;
  valor?: number;
  client_comments: Array<CommentDataTypes>;
  tasks: Array<BiddingTaskTypes>;
  bidding_info: Array<BiddingInfoTypes>;
  status_bidding_info: Array<StatusBiddingInfoTypes>;
  has_requested_edital: boolean;
  contracts: BiddingContract[];
  has_summary: boolean;
  indexed_for_ai: boolean;
  managers: Array<ManagedBy>;
  monitors: Array<MonitoredBy>;
  garantia_proposta: boolean | null;
  garantia_contrato: boolean | null;
}

export interface BiddingsTypes {
  bidding_list: Array<BiddingData>;
  total_entries: number;
  count_biddings_today: number;
  count_biddings_future: number;
  biddings_by_state: Array<StateBiddingsFutureTypes>;
  solicitation_edital_status: boolean;
  solicitation_edital_message: string;
  bidding_expired: Record<string, BiddingData>;
  bidding_detail: BiddingData | null;
}

export interface RequestState {
  get_biddings: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  get_bidding: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  get_bidding_pr_bw: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  create_favorite_bidding: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  destroy_favorite_bidding: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };

  create_managed_bidding: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  destroy_managed_bidding: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };

  solicitar_edital: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };

  get_bidding_expired: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };

  biddings_overview: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
}

export interface CommentsRequestState {
  get_comments: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  create_comment: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  destroy_comment: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
}

export interface IndividualCommentRequestState {
  [key: string]: CommentsRequestState;
}

export interface CommentTypes {
  [key: string]: Array<CommentDataTypes>;
}

export interface BiddingState {
  readonly biddings: BiddingsTypes;
  readonly comments: CommentTypes;
  readonly request: RequestState;
  readonly comments_request: IndividualCommentRequestState;
}
